var _style, _defs, _rect, _defs2, _rect2, _defs3, _rect3, _defs4, _rect4, _defs5, _rect5, _defs6, _rect6, _defs7, _rect7, _defs8, _rect8, _defs9, _rect9, _defs0, _rect0, _defs1, _rect1, _defs10, _rect10, _defs11, _rect11, _defs12, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuardianLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "159.7px",
    height: "29.4px",
    viewBox: "0 0 159.7 29.4",
    style: {
      enableBackground: "new 0 0 159.7 29.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#03A765;}\n\t.st1{clip-path:url(#SVGID_4_);fill:#008EB1;}\n\t.st2{clip-path:url(#SVGID_6_);fill:#007A4A;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#007A4A;}\n\t.st4{clip-path:url(#SVGID_10_);fill:#0B3F5E;}\n\t.st5{clip-path:url(#SVGID_12_);fill:#0B3F5E;}\n\t.st6{clip-path:url(#SVGID_14_);fill:#0B3F5E;}\n\t.st7{clip-path:url(#SVGID_16_);fill:#0B3F5E;}\n\t.st8{clip-path:url(#SVGID_18_);fill:#0B3F5E;}\n\t.st9{clip-path:url(#SVGID_20_);fill:#0B3F5E;}\n\t.st10{clip-path:url(#SVGID_22_);fill:#0B3F5E;}\n\t.st11{clip-path:url(#SVGID_24_);fill:#0B3F5E;}\n\t.st12{clip-path:url(#SVGID_26_);fill:#0B3F5E;}\n\t.st13{clip-path:url(#SVGID_28_);fill:#0B3F5E;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M20.1,4.2V0c0,0-10.5,0-10.6,0C8.4,0,7.3,0.3,6.4,0.7C5,1.2,3.8,2.1,2.9,3.3C2,4.4,1.3,5.7,1,7.1 c-0.3,1.4-0.2,2.8,0.1,4.1c0.3,1.2,0.9,2.4,1.7,3.4c0.8,1,1.9,1.9,3.1,2.5c1.3,0.6,2.8,0.9,4.3,0.8c1.1-0.1,2.1-0.3,3-0.7 c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.5-0.3,0.7-0.4c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3-0.2c0.9-0.6,1.6-1.4,2.2-2.3c0.1-0.2,0.3-0.4,0.4-0.6c0.5-0.8,0.8-1.8,1-2.7 c0.3-1.5,0.2-3-0.3-4.4c0-0.2-0.1-0.3-0.2-0.5c-0.2-0.4-0.4-0.9-0.6-1.3c0-0.1-0.1-0.2-0.2-0.3H20.1 M9.7,13.7L9.7,13.7 C7.1,13.7,5,11.6,5,9c0-2.6,2.1-4.8,4.7-4.8c0,0,0.1,0,0.1,0h0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0.1,0.8,0.2c2,0.6,3.4,2.4,3.4,4.6 c0,2.5-1.8,4.5-4.2,4.7c0,0-0.1,0-0.1,0h0c-0.1,0-0.2,0-0.2,0C9.9,13.7,9.8,13.7,9.7,13.7C9.8,13.7,9.7,13.7,9.7,13.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -4.2,
    y: -5,
    className: "st0",
    width: 29.2,
    height: 27.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M19.7,19.5c0,5.5-4.4,9.9-9.8,9.9C4.4,29.4,0,25,0,19.5c0-2,0.6-3.8,1.5-5.3c1,1.6,2,2.5,3.1,3.1 c-0.3,0.7-0.5,1.4-0.5,2.2c0,3.2,2.5,5.7,5.7,5.7c3.1,0,5.7-2.6,5.7-5.7c0-1.1-0.3-2.1-0.8-2.9c0,0-0.1-0.1-0.1-0.1 c-1-1.6-2.8-2.7-4.8-2.7c0,0,0,0-0.1,0h0c0,0-0.1,0-0.1,0c-2,0-3.7-1.3-4.4-3.1c1.4-0.7,2.9-1.1,4.6-1.1c1.4,0,2.8,0.3,4,0.8 c0.1,0.1,0.2,0.1,0.4,0.2c1.2,0.6,2.3,1.4,3.1,2.5c0.1,0.1,0.1,0.1,0.2,0.2C18.9,15,19.7,17.1,19.7,19.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 4.5,
    className: "st1",
    width: 29.7,
    height: 29.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M18.2,6.2c-1.8-0.8-4.7-1.5-7.2-1.8c-0.3-0.1-0.6-0.1-0.9-0.2c-0.1,0-0.2,0-0.3,0l7.3,0 c0,0.1,0.1,0.2,0.2,0.3c0.2,0.4,0.4,0.8,0.6,1.3C18.1,5.9,18.1,6,18.2,6.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: -0.8,
    className: "st2",
    width: 18.3,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M14.6,16.4C14.6,16.4,14.6,16.4,14.6,16.4C14.6,16.4,14.6,16.4,14.6,16.4C14.6,16.4,14.6,16.4,14.6,16.4 C14.6,16.4,14.6,16.5,14.6,16.4c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.5,0.3-0.7,0.4c-0.1,0-0.2,0.1-0.3,0.1 c-0.5-1.2-1.8-2.6-3.5-3.3c0,0-0.1,0-0.1,0c0,0,0.1,0,0.1,0C11.9,13.8,13.6,14.8,14.6,16.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.8,
    y: 8.7,
    className: "st3",
    width: 14.8,
    height: 13.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M158,11.9c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3h-0.4v0.6H158 M158.3,12.1l0.4,0.6h-0.4l-0.4-0.5 h-0.3v0.5h-0.3v-1.6h0.7c0.4,0,0.6,0.2,0.6,0.6C158.6,11.9,158.5,12.1,158.3,12.1 M159.3,11.9c0-0.8-0.7-1.4-1.4-1.4 c-0.7,0-1.4,0.6-1.4,1.4c0,0.8,0.7,1.4,1.4,1.4C158.7,13.3,159.3,12.7,159.3,11.9 M159.7,11.9c0,1-0.8,1.8-1.8,1.8 c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8C158.9,10.1,159.7,10.9,159.7,11.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 151.1,
    y: 5.1,
    className: "st4",
    width: 13.6,
    height: 13.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M148.5,10c-1.6,0-3,0.6-4.2,1.5v-1h-4.2v14.7h4.2v-9.5c1-1.2,2.1-1.8,3.2-1.8c2,0,3.1,1.3,3.1,3.6v7.7h4.2 v-8.1C154.9,12.8,152.4,10,148.5,10"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 135.1,
    y: 5,
    className: "st5",
    width: 24.8,
    height: 25.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M133.4,11.3c-1.1-0.7-2.5-1.2-4.1-1.2c-4,0-7.3,3.4-7.3,7.7c0,4.3,3.3,7.7,7.3,7.7c1.6,0,3-0.4,4.1-1.2 v0.9h4.2V10.5h-4.2V11.3z M133.4,20.2c-0.9,1.3-2.2,1.7-3.4,1.7c-2.2,0-3.8-1.9-3.8-4c0-2.2,1.6-4.1,3.8-4.1 c1.2,0,2.5,0.4,3.4,1.7V20.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 116.9,
    y: 5.1,
    className: "st6",
    width: 25.7,
    height: 25.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 115.7,
    y: 10.5,
    width: 4.2,
    height: 14.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 110.7,
    y: 5.5,
    className: "st7",
    width: 14.2,
    height: 24.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 115.7,
    y: 4.1,
    width: 4.2,
    height: 4.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 110.7,
    y: -0.9,
    className: "st8",
    width: 14.2,
    height: 14.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M108.5,11.3c-1.1-0.7-2.5-1.2-4.1-1.2c-4,0-7.3,3.4-7.3,7.7c0,4.3,3.3,7.7,7.3,7.7c1.6,0,3-0.4,4.1-1.2 v0.9h4.2V4.1h-4.2V11.3z M108.5,20.2c-0.9,1.3-2.2,1.7-3.4,1.7c-2.2,0-3.8-1.9-3.8-4.1c0-2.2,1.6-4,3.8-4c1.2,0,2.5,0.4,3.4,1.7 V20.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 92.1,
    y: -0.9,
    className: "st9",
    width: 25.7,
    height: 31.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M91.6,10.5h-4.2v14.7h4.2v-8.8c1.2-1.4,2.8-2,5.1-2.1v-4.1c-2.2,0-3.8,0.7-5.1,1.9V10.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3,
    y: 5.2,
    className: "st10",
    width: 19.4,
    height: 25
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M80.5,11.3c-1.1-0.7-2.5-1.2-4.1-1.2c-4,0-7.3,3.4-7.3,7.7c0,4.3,3.3,7.7,7.3,7.7c1.6,0,3-0.4,4.1-1.2v0.9 h4.2V10.5h-4.2V11.3z M80.5,20.2c-0.9,1.3-2.2,1.7-3.4,1.7c-2.2,0-3.8-1.9-3.8-4c0-2.2,1.6-4.1,3.8-4.1c1.2,0,2.5,0.4,3.4,1.7 V20.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 5.1,
    className: "st11",
    width: 25.7,
    height: 25.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M63,19.9c-1,1.2-2.1,1.8-3.2,1.8c-2,0-3.1-1.3-3.1-3.6v-7.7h-4.2v8.1c0,4.3,2.6,7.1,6.4,7.1 c1.6,0,3-0.6,4.2-1.5v1h4.2V10.5H63V19.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4,
    y: 5.5,
    className: "st12",
    width: 24.8,
    height: 25.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M40.2,13.7v4.1h4.9c-0.7,1.9-2.6,3.6-5.4,3.6c-4,0-6.4-3-6.4-6.4c0-4.3,2.7-6.9,6.6-6.9 c1.6,0,3.6,0.4,4.9,2.4h4.9C48.1,6,44,3.8,39.8,3.8c-6.1,0-11,4.6-11,11.2c0,5.8,4.5,10.6,10.8,10.6c2.9,0,5-1,6.4-2.5v2.1h4V13.7 H40.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: -1.2,
    className: "st13",
    width: 31.3,
    height: 31.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardianLogo);
export default __webpack_public_path__ + "static/media/guardian-logo.f33b01d63935746ae4ce1a7a416b8383.svg";
export { ForwardRef as ReactComponent };